export enum UserType {
  'Regular' = 'Regular',
  'Driver' = 'Driver',
}
